import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admins--redirect"
export default class extends Controller {
  static values = {
    url: String,
    action: String,
    frame: String
  }
  connect() {
    Turbo.visit(this.urlValue, { action: this.actionValue, frame: this.frameValue })
  }
}
